const DEFAULT_API_URL = 'http://localhost:8081';
function normalizeSession(raw) {
    return {
        sessionId: String(raw.session_id ?? raw.sessionId ?? ''),
        ephemeralToken: String(raw.ephemeral_token ?? raw.ephemeralToken ?? ''),
        config: raw.config ?? {
            theme: {},
            avatarEnabled: true,
            greeting: '',
            allowedTools: [],
            policy: { maxSessionDuration: 1800, rateLimitPerMinute: 60, requireConsent: false },
        },
        expiresAt: String(raw.expires_at ?? raw.expiresAt ?? ''),
        avatarStreamPlayerUrl: (raw.avatar_stream_player_url ?? raw.avatarStreamPlayerUrl),
        avatarStreamSignalingUrl: (raw.avatar_stream_signaling_url ?? raw.avatarStreamSignalingUrl),
        realtimeWsUrl: (raw.realtime_ws_url ?? raw.realtimeWsUrl),
    };
}
export class APIClient {
    constructor(config) {
        this.apiUrl = config.apiUrl || DEFAULT_API_URL;
        this.authToken = config.authToken;
    }
    async createSession(tenantId, userId, authAssertion) {
        const response = await fetch(`${this.apiUrl}/v1/sessions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(this.authToken && { Authorization: `Bearer ${this.authToken}` }),
            },
            body: JSON.stringify({
                tenant_id: tenantId,
                user_id: userId,
                auth_assertion: authAssertion,
            }),
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to create session');
        }
        return normalizeSession(await response.json());
    }
    async refreshToken(sessionId) {
        const response = await fetch(`${this.apiUrl}/v1/sessions/${sessionId}/refresh-token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(this.authToken && { Authorization: `Bearer ${this.authToken}` }),
            },
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to refresh token');
        }
        const raw = await response.json();
        return {
            ephemeralToken: raw.ephemeral_token ?? raw.ephemeralToken,
            expiresAt: raw.expires_at ?? raw.expiresAt,
        };
    }
    async endSession(sessionId) {
        const response = await fetch(`${this.apiUrl}/v1/sessions/${sessionId}/end`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(this.authToken && { Authorization: `Bearer ${this.authToken}` }),
            },
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to end session');
        }
    }
}
